"use client";
import { useIsMobile } from "@/hooks/use-is-mobile";
import { useLocale } from "@/context/LocaleContext";
import { I18nData } from "@/types/i18n";
import { Branding } from "@/types/branding";
import { processAndCleanHtml } from "@/utils/process-html-links";
import { formatDateTime } from "@/utils/format-date";
import InfoBox from "./info-box";
import AdditionalInfo from "./additional-info-box/additional-info-box";
import Search from "./search/search";

interface TopSectionProps {
  i18nData?: I18nData;
  branding: Branding | null;
  agreementsLastUpdatedAt: string | null;
}

export default function TopSection({
  i18nData,
  branding,
  agreementsLastUpdatedAt,
}: TopSectionProps) {
  const isMobile = useIsMobile();
  const { locale } = useLocale();

  const openInNewWindow = branding?.open_in_new_window !== false;
  const infoBoxHtml = processAndCleanHtml(
    i18nData?.[locale]?.info_box,
    openInNewWindow,
  );
  const additionalInfoHtml = processAndCleanHtml(
    i18nData?.[locale]?.additional_info,
    openInNewWindow,
  );

  const showLastUpdatedAt = branding?.show_last_updated_at === true;
  const formattedAgreementsLastUpdatedAt = formatDateTime(
    agreementsLastUpdatedAt,
    locale,
  );
  const agreementsLastUpdatedOnText =
    i18nData?.[locale]?.agreements_last_updated_on;

  const InfoBoxes = (
    <div id="infoWrapper">
      {showLastUpdatedAt && formattedAgreementsLastUpdatedAt && (
        <div className="agreementsLastUpdatedAt">
          <span>{agreementsLastUpdatedOnText} </span>
          {formattedAgreementsLastUpdatedAt}
        </div>
      )}
      {infoBoxHtml && <InfoBox infoBoxHtml={infoBoxHtml} />}
      {additionalInfoHtml && (
        <AdditionalInfo additionalInfoHtml={additionalInfoHtml} />
      )}
    </div>
  );

  return (
    <div id="topSection">
      {isMobile ? (
        <>
          {InfoBoxes}
          <Search i18nData={i18nData} branding={branding} />
        </>
      ) : (
        <>
          <Search i18nData={i18nData} branding={branding} />
          {InfoBoxes}
        </>
      )}
    </div>
  );
}
